import logo from "@/assets/new-logo.svg";
import { FormattedMessage } from "react-intl";

type SplashScreenProps = {
  fadingOut: boolean;
};

export function SplashScreen({ fadingOut }: SplashScreenProps) {
  return (
    <div
      className={`fixed inset-0 z-[60] flex flex-col items-center justify-center bg-[#ede7e4] transition-opacity duration-500 ${
        fadingOut ? "opacity-0" : "opacity-100"
      }`}
    >
      <div className="relative flex h-32 w-32 items-center justify-center rounded-3xl bg-white/80 shadow-xl backdrop-blur-md splash-pop">
        <div className="absolute inset-0 rounded-3xl bg-[#d2a293]/15 blur-2xl splash-glow" />
        <img src={logo} alt="HAMD logo" className="relative h-16 w-16 splash-float" />
      </div>

      <div className="mt-6 h-1.5 w-32 overflow-hidden rounded-full bg-white/60">
        <div className="h-full w-full bg-[#d2a293] splash-progress" />
      </div>

      <p className="mt-4 text-sm text-[#6b5a55] tracking-wide">
        <FormattedMessage id="splash.loading" />
      </p>
    </div>
  );
}
